import { useCallback } from "react"
import { Link, router, useFocusEffect, usePathname } from "expo-router"
import { useDeepLinkReroute, useLatestBranchOpenEvent } from "@/stores/branch"
import FullScreenLoader from "@/components/loading/FullScreenLoader"
import { useStore } from "@nanostores/react"
import { $authToken } from "@/stores/auth"
import { setStatusBarStyle } from "@/stores/statusBarStyle"

export default function Missing() {
  const event = useLatestBranchOpenEvent()
  const path = usePathname()
  const auth = useStore($authToken)
  const deepLink = useDeepLinkReroute()

  useFocusEffect(
    useCallback(() => {
      setStatusBarStyle("dark")
      if (!auth) {
        router.replace("/")
      }

      if (path.startsWith("/dataUrl")) {
        // this is a share intent, let it go through
        return
      }

      if (event) {
        deepLink()
      }
    }, [event])
  )

  return (
    <FullScreenLoader>
      {event ? (
        "Loading..."
      ) : (
        <Link href="/" className="underline">
          Go Home
        </Link>
      )}
    </FullScreenLoader>
  )
}
